import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

const duas = [
  {
    arabic: "رَبِّ زِدْنِي عِلْمًا",
    pronunciation: "Rabbi zidni ilma",
    translation: "My Lord, increase me in knowledge"
  },
  {
    arabic: "اللهم انفعني بما علمتني",
    pronunciation: "Allahumma anfa‘ni bima ‘allamtani",
    translation: "O Allah, benefit me with what You have taught me"
  },
  {
    arabic: "اللهم اشرح لي صدري",
    pronunciation: "Allahumma ishrah li sadri",
    translation: "O Allah, expand my chest (grant me confidence)"
  },
];

export default function DuasBar() {
  return (
    <div className="w-full my-4 px-4" style={{ minHeight: "140px" }}>
      <div className="bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 backdrop-blur-xl rounded-2xl p-4 border border-white/20 shadow-xl">
        <div className="flex items-center justify-center gap-2 mb-3">
          <div className="text-lg">🤲</div>
          <span className="font-semibold text-lg bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 bg-clip-text text-transparent">Daily Duas</span>
        </div>
        <Swiper
          loop={true}
          spaceBetween={20}
          slidesPerView={1}
          navigation={true}
          modules={[Navigation]}
          className="w-full"
          style={{ minHeight: "100px" }}
        >
          {duas.map((dua, idx) => (
            <SwiperSlide key={idx}>
              <div className="w-full text-center py-4 px-6 bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/30 hover:shadow-xl transition-all duration-300">
                <div className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-2 leading-relaxed">{dua.arabic}</div>
                <div className="text-base text-blue-600 font-medium mb-2">{dua.pronunciation}</div>
                <div className="text-sm text-gray-600 italic">{dua.translation}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <style>{`
        .swiper-button-next, .swiper-button-prev {
          color: #8b5cf6;
          top: 50%;
          width: 40px;
          height: 40px;
          background: rgba(255,255,255,0.9);
          backdrop-blur-sm;
          border-radius: 50%;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          border: 1px solid rgba(255,255,255,0.3);
          transform: translateY(-50%);
          transition: all 0.3s ease;
        }
        .swiper-button-next:hover, .swiper-button-prev:hover {
          background: rgba(255,255,255,1);
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
          transform: translateY(-50%) scale(1.1);
        }
        .swiper-button-next { right: -10px; }
        .swiper-button-prev { left: -10px; }
        .swiper-button-next:after, .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        .swiper-pagination-bullet {
          background: rgba(139, 92, 246, 0.3);
          opacity: 1;
        }
        .swiper-pagination-bullet-active {
          background: #8b5cf6;
        }
      `}</style>
    </div>
  );
} 